/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Enum_Billingrhytm_YearlyInputs */



/**

* @param {_Enum_Billingrhytm_YearlyInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _enum_billingrhytm_yearly = /** @type {((inputs?: _Enum_Billingrhytm_YearlyInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Enum_Billingrhytm_YearlyInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jährlich")
});